import React from "react";
import { styled } from "@mui/material/styles";
import { useAuth0 } from "@auth0/auth0-react";
import {
  AppBar as MuiAppBar,
  Button,
  Toolbar as MuiToolbar,
  Box,
  Typography,
} from "@mui/material";
import { APP_DETAILS, ROUTES } from "../../../constants";
import useBreakpoints from "../../../hooks/useBreakpoints";
import UserDropdown from "../../../components/UserDropdown";
import { useHistory } from "react-router-dom";

// Styled Components
const AppBar = styled(MuiAppBar)(({ theme }) => ({
  background: theme.header.background,
  color: theme.header.color,
}));

const Toolbar = styled(MuiToolbar)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    minHeight: 96,
  },
  [theme.breakpoints.down("sm")]: {
    minHeight: 64,
  },
}));

const Title = styled(Typography)(({ theme }) => ({
  color: theme.sidebar.header.color || "inherit",
}));

function AppBarComponent() {
  const { loginWithRedirect, isAuthenticated } = useAuth0();
  const history = useHistory();
  const { isXs, isSm, isUpMd } = useBreakpoints();

  const handleButtonClick = () => {
    if (isAuthenticated) {
      history.push(ROUTES.MAP);
    } else {
      loginWithRedirect({ appState: { returnTo: ROUTES.MAP } });
    }
  };

  return (
    <>
      <AppBar position="fixed" elevation={0}>
        <Toolbar>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
          >
            <Box display="flex" alignItems="center">
              <Title ml={2} variant={isUpMd ? "h3" : "h4"} noWrap>
                {isUpMd ? APP_DETAILS.NAME : APP_DETAILS.SHORT_NAME}
              </Title>
            </Box>
            <Box display="flex" alignItems="center" gap={3}>
              <Button
                variant="outlined"
                color="secondary"
                sx={{
                  color: "white",
                  border: "2px solid",
                  borderColor: "secondary.main",
                  "&:hover": {
                    borderColor: "secondary.dark",
                    backgroundColor: "rgba(255, 255, 255, 0.08)",
                  },
                }}
                size={isXs ? "small" : isSm ? "medium" : "large"}
                onClick={handleButtonClick}
              >
                {isAuthenticated
                  ? isXs
                    ? "Dashboard"
                    : "View Dashboard"
                  : isXs
                  ? "Log in"
                  : "Log in to Dashboard"}
              </Button>

              {!isAuthenticated && (
                <Button
                  variant="contained"
                  color="secondary"
                  size={isXs ? "small" : isSm ? "medium" : "large"}
                  onClick={() => history.push(ROUTES.PUBLIC_FORMS)}
                >
                  Public Forms
                </Button>
              )}

              {isAuthenticated && <UserDropdown />}
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <Toolbar /> {/* Spacer Toolbar */}
    </>
  );
}

export default AppBarComponent;
